import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useContext } from 'react';
import { CommentContext } from '../../CommentContext';
/**
 * We need these data attributes on a certain level of our comment views, so we have this component to make it easy
 * to include it in multiple places.
 */ const CommentDataAttrDiv = (props)=>{
    const { comment } = useContext(CommentContext);
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        "data-commentid": comment.commentId,
        "data-typeid": comment.typeId,
        "data-itemid": comment.itemId
    }, props));
};
CommentDataAttrDiv.displayName = 'CommentDataAttrDiv';
export default CommentDataAttrDiv;

//# sourceMappingURL=CommentDataAttrDiv.js.map